import PlayArrowIcon from '@mui/icons-material/PlayArrow';
function TestimonialCard({item, onPlay,}) {
  return (
    <div className="testimonial-card">
      <img
        src={item.image}
        alt={item.name}
      />

      <div className="overlay"></div>

      <button className="play-btn" onClick={() => onPlay(item.videoId)}   aria-label="Play testimonial video">
        <PlayArrowIcon />
      </button>

      <h4>{item.name}</h4>
    </div>
  );
}

export default TestimonialCard;